/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import classNames from 'classnames';
import Icon from '../../../_particles/icon/react/Icon';
import type { ExternalProps, NavigationItem } from '../types';
import ItemGrid from './ItemGrid';

const BurgerContentDesktop = ({ items }: ExternalProps): React$MixedElement => {
  return (
    <div className="burger-d">
      {items?.map((item, index) => (
        <ItemGrid key={index} item={item} modifier={index.toString()} />
      ))}
    </div>
  );
};

export default BurgerContentDesktop;
